import "./elements/dismissible-alert";
import "./elements/file-picker";
import "./elements/form-validation";
import "./elements/theme-switcher";
import "./elements/video-wrapper";

// HTML has loaded
document.addEventListener("DOMContentLoaded", () => {

    

}, false);

// Images, etc has loaded
window.addEventListener("load", () => {

    // Add code here

});

